<template>

  <div>

    <b-alert
      v-if="medicamentosList.length >= 5"
      variant="warning" 
      show
      class="text-center col-12"
      style="padding: 20px; font-size: 18px;"
    >
      Ya no puede agregar mas medicamentos
    </b-alert>
    <b-row class="mt-2" >
      <b-col cols="3">
        <label><h5>Alergias a medicamentos? </h5></label>
      </b-col>
      
      <b-col cols="2">
        <b-form-checkbox 
          switch 
          @change = "guardarAlergias"
          v-model="esalergico"
        >
          <span class="score">
            {{ esalergico ? 'Si' : 'No' }}
          </span>
        </b-form-checkbox>
      </b-col>
      
      <b-col v-if="esalergico" cols="7">
        <b-form-textarea 
          placeholder="Describa alergias a medicamentos..." 
          v-model="alergias" 
          @input = "agregarAlergia"
        />
      </b-col>
    </b-row>

    <b-form-group class="mt-1" v-if="medicamentosList.length < 5">
      <label for="">Medicamento:</label>
      <b-row>

        <!-- <b-col>
          <v-select 
            placeholder="Escribe el nombre del medicamento..." 
            v-model="selectedMedicamento"
            :options="filteredMedicamentos" 
            label="text" 
            @search="onSearchMedicamentos" 
            :loading="isLoading"
            :debounce="300">
            <template #no-options>
              {{ noMedicamentosMessage() }}
            </template>
          </v-select>
        </b-col> -->

        <b-col class="col-12">
          <SearchOpts
            v-model="selectedMedicamento"
            :searchService="searchMedicamentoByEstablecimiento"
            :placeholder="'Buscar medicamentos por nombre'"
            :omit="omitMedicamentos"
          />
        </b-col>

      </b-row>


      <b-card style="border:1px solid #c9c9c9" v-if="selectedMedicamento" class="my-3">
        <b-row class="d-flex align-items-center">
          <label class="col-2">Cantidad</label>
          <b-form-input 
            class="col-2 mx-1" 
            v-model="currentMedicamento.cantidad" 
            type="number" 
            min="0"
            :max="selectedMedicamento.cantidad" required
          />
          <label v-if="selectedMedicamento">
            Cant. maxima permitida: {{ selectedMedicamento.numMax }}
          </label>
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Dosis</label>

          <b-form-input v-model="currentMedicamento.dosisNumber" type="number" min="0" class="col-2 ml-1" />

          <v-select
            class="col-2 px-0"
            placeholder="Seleccione una opcion"
            v-model="currentMedicamento.dosisTipo"
            :options="dosisOpts"
            :reduce="option => option"
            label="text"
          />
        </b-row> 


        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Frecuencia</label>
          <b-form-input placeholder="Cada cuanto va a tomar" class="col-8 mx-1" v-model="currentMedicamento.frecuencia" />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Duracion</label>
          <b-form-input placeholder="Por cuanto tiempo va a tomar" v-model="currentMedicamento.duracion" class="col-8 mx-1" />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Via</label> 
          <v-select 
            class="col-4" 
            placeholder="Seleccione una opcion" 
            v-model="currentMedicamento.via" 
            :options="viaOpts"
            label="text" />
        </b-row>

      
        <b-row>
          <b-col>
            <label>Observación</label>
            <b-form-textarea 
              placeholder="Ingrese observaciones pertinentes" id="v-observacion"
              :state="errors.length > 0 ? false : null" 
              v-model="currentMedicamento.observacion" type="text" 
            />
          </b-col>

        </b-row>

        <b-row class="mt-2">

          <b-col class="d-flex justify-content-end">
            <b-button variant="info" @click="agregarMedicamento()" style="cursor: pointer">
              <i class="fas fa-solid fa-plus" style="margin-right: 10px" title="Agregar Diagnostico" />
              Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

    </b-form-group>
  </div> 

  
</template>


<script>
import vSelect from "vue-select";
import _ from "lodash";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { DOSIS_UNITS, formatDosis, getEstablecimientoLS } from '@/shared/helpers';
import { mapState } from 'vuex';

import { SearchOpts } from '@/shared/components';
import { medicamentosService } from '@/views/farmacia/services';

export default {
  name: 'RecetaFormulario',

  components: {
    vSelect,
    SearchOpts
  },

  data() {
    return {
      esalergico : false,
      alergias : '',
      medicamentosService,
      filteredMedicamentos: [],
      selectedMedicamento: null,
      isLoading: false,
      continuar: false,


      searchQuery: "",
      errors: [],

      medicamentosList: [],
      contadorMedicamento: 0,
      alertaOmitida: 0,

      currentMedicamento: {
        cantidad: 0,
        frecuencia: "",
        duracion: "",
        via: null,
        dosisNumber: 0,
        dosisTipo: null,
        observacion: ""
      },

      initCurrentMedicamento: {
        cantidad: 0,
        frecuencia: "",
        duracion: "",
        via: null,
        dosisNumber: 0,
        dosisTipo: null,
        observacion: ""
      },


      isRepeatedToday: false,

      viaOpts: [
        "ORAL",
        "PARENTERAL",
        "RECTAL",
        "TÓPICA",
        "INHALATORIA",
        "INTRADÉRMICA",
        "SUBCUTÁNEA",
        "INTRAMUSCULAR",
        "INTRAVENOSA",
      ],

      dosisOpts: DOSIS_UNITS,
    }
  },


  created() {
    this.debouncedGetMedicamentos = _.debounce(this.obtenerMedicamentos, 300);
    this.loadDataLS();
  },

  methods: {


    async searchMedicamentoByEstablecimiento(search){
      const establecimiento = getEstablecimientoLS();
      return medicamentosService.searchByTerm(search, establecimiento.id);
    },

    agregarAlergia(){
      if(this.esalergico === true){
        
        localStorage.setItem('alergias', this.alergias)
      }
    },

    guardarAlergias(){
      if(this.esalergico === false){
        this.alergias = 'Ninguna'
        localStorage.setItem('alergias', this.alergias)
      }else{
        this.alergias = ''
      }
    },


    loadDataLS() {
      const receta = JSON.parse(localStorage.getItem("atencionReceta"));
      if(!receta) return;

      receta.forEach(medicamento => {
        this.medicamentosList.push(medicamento);
      })
    },
    onSearchMedicamentos(search, loading) {
      if (search.length > 4) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetMedicamentos(search);
      } else {
        this.filteredMedicamentos = [];
        this.isLoading = false;
      }
      loading(false);
    },

    async obtenerMedicamentos(search) {
      const idCita = this.$route.params.id; // Obtener el ID de la cita
      const establecimientoId = parseInt(
        await this.fetchGetEstablecimiento(idCita),
        10
      );

      if (search && establecimientoId !== -1) {
        try {
          const query = `
            query GetMedicamentos(
              $search: String, 
              $establecimiento: String
            ) {
              allMedicamento(
                search         : $search,
                establecimiento: $establecimiento
              ) {
                id
                nombre
                numMax
                presentacion
              }
            }
          `;

          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
              establecimiento: establecimientoId.toString(),
            },
          });

          this.filteredMedicamentos = response.data.data.allMedicamento.map(
            (item) => ({
              value: item.id,
              text: item.nombre,
              cantidad: item.numMax,
              via: item.presentacion
            })
          );
          
          this.currentMedicamento.via = this.filteredMedicamentos[0].via
        } catch (error) {
          console.error("Error:", error.response ? error.response.data : error);
        }
      } else {
        this.filteredMedicamentos = [];
      }
    },


    async fetchGetEstablecimiento(idCita) {
      const query = `
        query qrgetCitaById($id: String!){
          getCitaId(idCit: $id) {
            cita {
              id
              fechaCita
              horaCita
              estado
              establecimiento{
                id
              }
            }  
          }
        }
      `;

      const varConsulta = { id: String(idCita), };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: varConsulta,
        });
        if (response.status === 200) {
          return response.data.data.getCitaId.cita[0].establecimiento.id;
        }
      } catch (error) {
        console.error("Error fetching establecimiento id:", error);
        return -1;
      }
    },


    noMedicamentosMessage() {
      if (this.searchQuery.length < 4) {
        return "Escribe más caracteres para buscar...";
      }
      if (this.isLoading) {
        return "Buscando medicamentos...";
      }
      if (this.searchFailed) {
        return "Error al buscar medicamentos. Intente de nuevo.";
      }
      if (this.filteredMedicamentos.length === 0 && !this.isLoading) {
        return "No se encontraron medicamentos que coincidan con tu búsqueda";
      }
      return "Escribe para buscar medicamentos...";
    },
    async showConfirmationDialog(title, text) {
      return new Promise((resolve) => {
        this.$swal({
          title: title,
          text: text,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          confirmButtonText: 'Sí',
          confirmButtonColor: '#d9534f',
        }).then(result => {
          
          if(result.value){
            this.alertaOmitida = 1
          }
          resolve(result.value); // Resolve con true si se presionó Sí, false si No
          
        });
      });
    },
    async fetchMedicamentoEnviados() {
      const query = `query MyQuery($idpaciente: ID) {
      getRecetasIdpaciente(idpaciente: $idpaciente) {
        status
        message
        recetas {
          alertaIgnorada
          cantidad
          dosis
          duracion
          estado
          estadoTransitorio
          id
          medicamento {
            id
            nombre
          }
          receta {
            consultamedica {
              cita {
                doctor {
                  id
                  idPersona {
                    primerNombre
                    primerApellido
                  }
                }
                paciente {
                  id
                  persona {
                    primerNombre
                    primerApellido
                  }
                }
                id
              }
            }
          }
          fechaCreacion
        }
      }
    }`;

      const idpaciente = localStorage.getItem('idPaciente');

      const variables = {
        idpaciente: idpaciente
      };

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query: query,
          variables: variables
        });

        let respuesta = response.data.data.getRecetasIdpaciente;
        let medenvArray = [];

        if (respuesta.message === "success") {
          for (let i = 0; i < respuesta.recetas.length; i++) {
            medenvArray.push({
              id: respuesta.recetas[i].medicamento.id,
              nombre: respuesta.recetas[i].medicamento.nombre,
              cantidad: respuesta.recetas[i].cantidad,
              fecha: respuesta.recetas[i].fechaCreacion
            });
          }

          let medRepetidos = [];
          if (medenvArray.length > 0) {
            for (let j = 0; j < medenvArray.length; j++) {
              if (medenvArray[j].nombre === this.selectedMedicamento.text) {
                console.log("este es el nombre", medenvArray[j].nombre);
                medRepetidos.push(medenvArray[j]);
              }
            }

            if (medRepetidos.length > 0) {
              const userConfirmed = await this.showConfirmationDialog(
                'Medicamento(s) ya enviado(s)',
                `El medicamento ${medRepetidos[0].nombre}, ya fue enviado con cantidad: ${medRepetidos[0].cantidad} en el ultimo mes. ¿Desea continuar?`
              );

              this.continuar = userConfirmed;
            } else {
              this.continuar = true;
            }
          } else {
            this.continuar = true;
          }
        }
      } catch (error) {
        console.error("este es el error", error);
      }
    },

    async agregarMedicamento() {
    
      const medicamento = { ...this.currentMedicamento };
      const maxCantMedicamento = this.selectedMedicamento.numMax;
      const dosis = formatDosis(medicamento.dosisNumber, medicamento.dosisTipo);
      if (
        !dosis
      ){
        this.$swal({
          title: "Campos incompletos",
          text: `Seleccione el tipo de la dosis.`,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        })
        return;
      }
      
      if (
        this.selectedMedicamento 
        && String(medicamento.dosisNumber ?? '').trim()
        && medicamento.frecuencia.trim() 
        && medicamento.duracion.trim() 
        && medicamento.observacion.trim()
      ) {

        if (
          maxCantMedicamento && parseInt(medicamento.cantidad, 10) > maxCantMedicamento
        ) {
          this.$swal({
            title: "Cantidad Excesiva",
            text: `La cantidad no puede ser mayor que el máximo permitido (${maxCantMedicamento}).`,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
          return; // Detiene la ejecución de la función aquí
        }
        this.alertaOmitida = 0
        await this.fetchMedicamentoEnviados();
        
        // dosis: `${medicamento.dosisNumber} ${medicamento.dosisTipo[0].text}`,
        if (this.continuar) {
          const nuevaReceta = {
            id: this.stMedicamentosList.length + 1,
            medicamentoID: this.selectedMedicamento.value,
            medicamento: this.selectedMedicamento.text,
            cantidad: medicamento.cantidad,
            dosis,
            
            frecuencia    : medicamento.frecuencia,
            duracion      : medicamento.duracion,
            via           : medicamento.via,
            observacion   : medicamento.observacion,
            alertaOmitida : this.alertaOmitida
          };

          this.medicamentosList.push(nuevaReceta);
          this.limpiarFormulario();
        }
      } else {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, complete todos los campos antes de agregar un medicamento.",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    },


  

    limpiarFormulario() {
      this.selectedMedicamento = null;
      this.currentMedicamento = {
        ...this.initCurrentMedicamento
      }
    }
  },


  computed: {
    ...mapState({
      stMedicamentosList: state => state.atencionCita.receta.medicamentosList,
      stMedicamentosSendToday: state => state.atencionCita.historialRecetas?.medicamentosSendToday
    }),

    omitMedicamentos(){

      const omits = this.stMedicamentosList.map(
        m => ({ id: m.medicamentoID, token: null })
      );

      return omits; 
    }
  },


  watch: {


    selectedMedicamento:{
      deep: true,

      handler(newValue){

        if (!newValue) return
        this.isRepeatedToday = !!this.stMedicamentosSendToday.find( m => m.id === newValue.value)

        if(!this.isRepeatedToday) return;

        this.$swal({
          title: "Medicamento Repetido",
          text: `No puede registrar el medicamento ${newValue.text} ya fue enviado el dia de hoy.`,
          icon: "error",
        });

        this.selectedMedicamento = null;
      }
    },

    medicamentosList: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setMedicamentosList", newValue);
      },
    },


  }
}
</script>
